export default "__VITE_ASSET__CTA8t1jQ__"